import { useContext, useEffect, useState } from "react";
import { Context } from "../../components/Context";
import {
  fetchData,
  GET_ALL_FORUM_CATEGORIES,
  GET_ALL_FORUM_LIST_BY_CATEGORY_ID,
  SEARCH_FORUM,
} from "../../components/Service";
import { Link } from "../../../node_modules/react-router-dom/dist/index";
import moment from "../../../node_modules/moment/moment";
import { scrollTop } from "../../components/Helper";
import CreateForum from "./CreateForum";
import Select from "react-select";
import { mapHTML } from "../map/mapHTML";

const Forum = () => {
  const [list, setList] = useState([]);
  const [cat, setCat] = useState([]);
  const [context,setContext] = useContext(Context);
  const [defaultCatId, setDefaultCatId] = useState(11);
  const [pageUrl, setPageUrl] = useState();
  const [notFound, setNotFound] = useState(false);
  const [searchPageUrl, setSearchPageUrl] = useState();
  const [searchKeyword, setSearchKeyword] = useState();
  const [selectedCat, setSelectedCat] = useState();
  const setListView = (value) => {
    setContext((prev) => ({...prev,listView:value  }))
  }

  const getAllCategories = () => {
    fetchData(GET_ALL_FORUM_CATEGORIES, "GET", "", false, false, (res) => {
      if (res.status) {
        setCat(res?.data);
        setDefaultCatId(res?.data[0]?.id);
        setSelectedCat({ label: res?.data[0]?.name, value: res?.data[0]?.id });
      } else {
        setCat([]);
      }
    });
  };

  const getList = (country_id, state_id, catId) => {
    let payload = {
      country_id: country_id,
      state_id: state_id,
      category_id: catId,
    };
    fetchData(
      pageUrl ? pageUrl : GET_ALL_FORUM_LIST_BY_CATEGORY_ID,
      "POST",
      payload,
      false,
      false,
      (res) => {
        if (res.status) {
          setNotFound(false);
          setList(res?.data);
        } else {
          setNotFound(true);
          setList([]);
        }
      }
    );
  };

  const handleSearch = (keyword) => {
    let payload = {
      keyword: keyword,
    };
    fetchData(
      searchPageUrl ? searchPageUrl : SEARCH_FORUM,
      "POST",
      payload,
      false,
      false,
      (res) => {
        if (res.status) {
          setNotFound(false);
          setList(res?.data?.result);
        } else {
          setNotFound(true);
          setList([]);
        }
      }
    );
  };

  const updatePageUrl = (url) => {
    if (searchKeyword) {
      setSearchPageUrl(url);
    } else {
      setPageUrl(url);
    }
  };

  //
  const resetSearch = () => {
    setPageUrl();
    setSearchKeyword("");
    setSearchPageUrl();
  };

  useEffect(() => {
    if (context?.countryId && context?.stateId && defaultCatId) {
      setPageUrl();
      setSearchKeyword("");
      setSearchPageUrl();
      getList(context?.countryId, context?.stateId, defaultCatId);
    }
  }, [context?.stateId, defaultCatId]);

  useEffect(() => {
    scrollTop();
    if (context?.countryId && context?.stateId && defaultCatId) {
      getList(context?.countryId, context?.stateId, defaultCatId);
    }
  }, [pageUrl]);

  useEffect(() => {
    if (searchKeyword) {
      if (searchKeyword.length > 2) {
        handleSearch(searchKeyword);
      }
    } else {
      getList(context?.countryId, context?.stateId, defaultCatId);
    }
  }, [searchKeyword, searchPageUrl]);

  const createForum = () => {
    if (context?.userToken) {
      window.$("#createForumModal").modal("show");
    } else {
      setContext((prev) =>( {...prev, loginLocation: {model:true, name:"#createForumModal"}}));

      window.$("#loginModal").modal("show");
    }
  };

  useEffect(() => {
    scrollTop();
    getAllCategories();
  }, []);

  const openMapWithCircle = async ({ country, state, city, _id }) => {
    try {
      const query = `${city}, ${state}, ${country}`;
      const res = await fetch(
        `https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(
          query
        )}&format=json`
      );
      const data = await res.json();
      if (data.length > 0) {
        const { lat, lon } = data[0];
        var myWindow = window.open(
          "",
          `My${_id}${Math.floor(Math.random() * 100000)}`,
          "width=800,height=800"
        );
        myWindow.document.write(mapHTML(parseFloat(lat), parseFloat(lon)));
        // Call the mapHTML function with lat and lon
      }
    } catch (error) {
      console.error("Failed to fetch location:", error);
    }
  };

  return (
    <>
      <div className="col-lg-12">
        <div className="card card-forum">
          <div className="card-header usa-bg">
            <div className="national-bg">
              <div className="row d-flex align-items-center ind1">
                <div className="col-lg-3">
                  <h4 class="text-white d-flex mb-0 py-2">Forums</h4>
                </div>
                <div className="col-lg-9 ms-auto text-start text-lg-end ">
                  <div class="input-group innersearch me-1 me-lg-0 ms-0 ms-lg-1 mt2px mb2px height30">
                    <input
                      type="text"
                      class="form-control py-1"
                      placeholder="Search here..."
                      name="keyword"
                      onChange={(e) => setSearchKeyword(e.target.value)}
                      value={searchKeyword}
                      autoComplete="off"
                    />
                  </div>
                  <button
                    class="btn btn-light btn-find font13 py-2 me-1 me-lg-0 ms-0 ms-lg-1 px-2 px-lg-3 rounded-1 height30 mb2px mt2px"
                    onClick={resetSearch}
                  >
                    <i class="fi fi-br-refresh "></i>
                  </button>
                  <Select
                    options={cat
                      ?.sort((a, b) => a.name.localeCompare(b.name)) 
                      ?.map((item) => ({
                      label: item.name,
                      value: item.id,
                      data: item.name,
                    }))}
                    value={selectedCat}
                    onChange={(selected) => {
                      setSelectedCat(selected);
                      setDefaultCatId(selected?.value);
                      console.log(selected?.data);
                    }}
                    placeholder="Select category"
                    className={`selectpicker custom-react-select custom-react-select-w200 me-1 me-lg-0 ms-0 ms-lg-1 mt2px mb2px height30`}
                    classNamePrefix="react-select"
                  />
                  <button
                    class="btn btn-warning btn-find font11 py-2 me-1 me-lg-0 ms-0 ms-lg-1 px-1 px-lg-2 rounded-1 height30 mb2px mt2px"
                    onClick={createForum}
                  >
                    Create Forums
                  </button>
                  {context.listView ? (
                    <>
                      <div class="list-frid-view cursor-pointer  ms-lg-1">
                        <img
                          src="/assets/images/list-active.png"
                          alt="..."
                          className="me-1"
                        />
                      </div>
                      <div
                        class="list-frid-view cursor-pointer "
                        onClick={() => setListView(false)}
                      >
                        <img
                          src="/assets/images/grid-inactive.png"
                          alt="..."
                          className="me-1"
                        />
                      </div>
                    </>
                  ) : (
                    <>
                      <div
                        class="list-frid-view cursor-pointer  ms-lg-1 "
                        onClick={() => setListView(true)}
                      >
                        <img
                          src="/assets/images/list-inactive.png"
                          alt="..."
                          className="me-1"
                        />
                      </div>
                      <div class="list-frid-view cursor-pointer ">
                        <img
                          src="/assets/images/grid-active.png"
                          alt="..."
                          className="me-1"
                        />
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
          {context.listView ? (
            <div className="card-body bg-white p-1 body-minh">
              <div className="table-responsive">
                <table className="table table-striped">
                  <thead>
                    <tr className="table-active">
                      <th scope="col">Title</th>
                      <th scope="col"></th>

                      <th scope="col">Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {list?.data &&
                      list?.data?.length > 0 &&
                      list?.data?.map((item) => (
                        <tr key={item.id}>
                          <td>
                            
							<Link to={`/forums/${item.id}`}> {item?.title ?? "N/A"}</Link>
                          </td>
                          <td>
                            <span className="">
                              {item?.image ? (
                                <img
                                  className="mx-2 cursor-pointer mx-2"
                                  src="/assets/images/icons/photo-img.png"
                                  alt="photo"
                                  onClick={
                                    new Function(
                                      "window.open('" + item?.image + "')"
                                    )
                                  }
                                />
                              ) : (
                                <span className="mx-2 empty-icon-margin"></span>
                              )}

                              {item?.use_address_map === 1 ? (
                                <img
                                  className="cursor-pointer mx-2"
                                  onClick={() => {
                                    console.log("first");
                                    openMapWithCircle({
                                      country: item?.country_id?.c_meta_title,
                                      state: item.state_id.name,
                                      city: item.city_id.name,
                                      _id: item._id,
                                    });
                                  }}
                                  src="/assets/images/icons/map-pin.png"
                                  alt="map"
                                />
                              ) : (
                                <span className="mx-2 empty-icon-margin"></span>
                              )}
                            </span>
                          </td>

                          
                          <td>
						  {item.created_at
                                    ? moment(item.created_at).format(
                                        "DD-MMM-YYYY hh:mm a"
                                      )
                                    : ""}
                          </td>
                        </tr>
                      ))}

                    {notFound && (
                      <tr>
                        <td
                          className="text-center h6 text-danger py-3"
                          colSpan={4}
                        >
                          No Records Found!
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              {list?.data && (
                <nav className="pt-3">
                  <ul className="pagination justify-content-end">
                    <li
                      className={`page-item ${
                        list.prev_page_url ? "" : "disabled"
                      }`}
                    >
                      <button
                        type="button"
                        className="page-link"
                        onClick={() => setPageUrl(list.prev_page_url)}
                      >
                        <span aria-hidden="true">&laquo;</span> Previous
                      </button>
                    </li>
                    <li
                      className={`page-item ${
                        list.next_page_url ? "" : "disabled"
                      }`}
                    >
                      <button
                        type="button"
                        className="page-link"
                        onClick={() => setPageUrl(list.next_page_url)}
                      >
                        Next <span aria-hidden="true">&raquo;</span>
                      </button>
                    </li>
                  </ul>
                </nav>
              )}
            </div>
          ) : (
            <div className="card-body bg-white p-1 body-minh">
              <div className="row">
                {list?.data &&
                  list?.data?.length > 0 &&
                  list?.data?.map((item) => (
                    <div
                      key={item.id}
                      className="col-xxl-3 col-xl-3 col-lg-3 col-md-6 col-sm-6 event_n mb-1"
                    >
                      <div className="card-grid-2 hover-up h-100 mb-0">
                        <div className="card-block-info position-relative">
                          <h6>
                            <Link to={`/forums/${item.id}`}>{item.title}</Link>
                          </h6>
                          <p
                            class="color-text-paragraph mt-2"
                            dangerouslySetInnerHTML={{
                              __html: item?.description,
                            }}
                          ></p>
                          <div className="card-2-bottom mt-30">
                            <div className="row d-flex align-items-center">
                              <div className="col-7 ">
                                <img
                                  src="/assets/images/icons/cal.png"
                                  className="me-2"
                                />
                                <span className="text-muted">
                                  {item.created_at
                                    ? moment(item.created_at).format(
                                        "DD-MMM-YYYY hh:mm a"
                                      )
                                    : ""}
                                </span>
                              </div>
                              <div className="col-5 ps-0 text-end">
                                <Link
                                  to={`/forums/${item.id}`}
                                  className="btn btn-apply-now font11"
                                >
                                  View More
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                {notFound && (
                  <div className="text-center h6 text-danger py-3">
                    No Records Found!
                  </div>
                )}
              </div>
              {list?.data && (
                <nav className="pt-3">
                  <ul className="pagination justify-content-end">
                    <li
                      className={`page-item ${
                        list.prev_page_url ? "" : "disabled"
                      }`}
                    >
                      <button
                        type="button"
                        className="page-link"
                        onClick={() => updatePageUrl(list.prev_page_url)}
                      >
                        <span aria-hidden="true">&laquo;</span> Previous
                      </button>
                    </li>
                    <li
                      className={`page-item ${
                        list.next_page_url ? "" : "disabled"
                      }`}
                    >
                      <button
                        type="button"
                        className="page-link"
                        onClick={() => updatePageUrl(list.next_page_url)}
                      >
                        Next <span aria-hidden="true">&raquo;</span>
                      </button>
                    </li>
                  </ul>
                </nav>
              )}
            </div>
          )}
        </div>
      </div>
      {/* {context?.userToken &&  */}
      <CreateForum categoryList={cat} />
      {/* } */}
    </>
  );
};

export default Forum;
